import { render } from "./marchvegas.vue?vue&type=template&id=166dd79a"
import script from "./marchvegas.vue?vue&type=script&lang=js"
export * from "./marchvegas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__